<template>
</template>

<script>
export default {
  name: "EditSectionBase",
  props: {
    slideSequence: Object
  },
  components: {
    
  },
  data: function () {
    return {
      useTextFrom: 'Slide',
      prefixTextTemplate: '[slideNum]/[totalSlides]:\\n',
      // suffixTextTemplate: '\\n#TweetMySlides'
      suffixTextTemplate: '',
      includeCreditTweet: 'Yes'
    };
  },
  watch: {
    includeCreditTweet: function(newValue) {
      // console.log('includeCreditTweet', newValue);
      if (newValue === 'Yes') {        
        this.slideSequence.addCreditsTweet();
        this.$appInsights.trackEvent('User enabled Credit tweet');
        this.$ga.event('Credit tweet', 'enabled', 'Create > Edit section');
      } else {
        this.slideSequence.removeCreditsTweet();
        this.$appInsights.trackEvent('User disabled Credit tweet');
        this.$ga.event('Credit tweet', 'disabled', 'Create > Edit section');
      }
    }
  },
  methods: {
    next () {
      this.$appInsights.trackEvent('User clicked "Next".  Generating tweetSequence');
      this.$ga.event('"Next" button', 'clicked', 'Create > Edit section');

      // Generate the full sequence including generated properties
      let seq = Object.assign({}, this.slideSequence);

      seq._slides.forEach((slide, index) => {
        slide.editText = this.$refs.editSectionSlides[index].computedSlideText;
      });
      // console.log('seq', seq);

      let tweetSequence = {
        fileId: seq._fileId,
        slides: seq._slides.map(slide => {
          return {
            slideNum: slide.slideNum,
            slideImage: slide.slideImage,
            slideText: slide.editText
          }
        })
      };

      // console.log('tweetSequence', tweetSequence); 

      // Pass up to parent in event
      this.$emit('next', tweetSequence);
    },
    cancel () {
      this.$appInsights.trackEvent('User cancelled Edit section');
      this.$ga.event('"Cancel" button', 'clicked', 'Create > Edit section');
      this.$emit('cancel');
    },    
    setUseTextFromAs(useTextFrom) {
      if (this.useTextFrom === useTextFrom) {
        return;
      }

      switch (useTextFrom) {
        case 'Slide':
          this.slideSequence.setSlideTextAsEditText();
          break;
        case 'Notes':
          this.slideSequence.setNotesTextAsEditText();
          break;
        case 'Blank':
          this.slideSequence.setBlankTextAsEditText();
          break;
      }
      this.useTextFrom = useTextFrom;

      this.$appInsights.trackEvent('User changed setUseTextFromAs to: ' + useTextFrom);
      this.$ga.event('SetUseTextFromAs', useTextFrom, 'Create > Edit section');
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/create/EditSectionBase.vue